import React from 'react';
import './no-disponible.css';
import { getParameterByName } from '../../../api/http-client';

const addZero = (number) => (`0${number}`).slice(-2);

const NoDisponible = (props) => {
  const month = [];
  month[0] = 'Enero';
  month[1] = 'Febrero';
  month[2] = 'Marzo';
  month[3] = 'Abril';
  month[4] = 'Mayo';
  month[5] = 'Junio';
  month[6] = 'Julio';
  month[7] = 'Agosto';
  month[8] = 'Septiembre';
  month[9] = 'Octubre';
  month[10] = 'Noviembre';
  month[11] = 'Diciembre';

  const mensaje = props.mensaje ? props.mensaje : 'Más opciones para este paquete';
  const datos = {
    destino: getParameterByName('d'),
    origen: getParameterByName('origen'),
    salida: getParameterByName('s'),
    distribucion: getParameterByName('h'),
  };

  const now = new Date();
  const date = new Date(`${datos.salida}T00:00:00`);
  const mes = addZero(date.getMonth() + 1);
  let firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const mesString = month[date.getMonth()];
  if (firstDate.getFullYear() + firstDate.getMonth() === now.getFullYear() + now.getMonth()) {
    firstDate = now;
  }
  const desde = `${date.getFullYear()}-${mes}-${addZero(firstDate.getDate())}`;
  const hasta = `${date.getFullYear()}-${mes}-${addZero(lastDate.getDate())}`;

  const urlListaPaquetes = `${process.env.RAZZLE_URL_PATH}/lista-de-paquetes/${
    datos.origen}/${
    datos.destino}/${
    mesString}/${
    datos.distribucion
  }?desde=${desde
  }&hasta=${hasta}`;

  return (
    <div className='seccion-back'>
      <div className='container'>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className='panel panel-default sin-paquetes text-center mb-8'>
          <div className='panel-body p-4'>
            Esta salida no esta disponible o ya fue vendida
          </div>
        </div>
        <div className='panel panel-default'>
          <div className='panel-body center-block text-center'>
            <a className='btn-vuelo-hotel' href={urlListaPaquetes}>{mensaje}</a>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
};

export default NoDisponible;
